var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoughnutChartWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17181",
    transform: "translate(534 300)",
    fill: "#fff",
    stroke: "#707070",
    d: "M0 0h30v30H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 1391",
    transform: "translate(-534 -300)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 17183",
    fill: "none",
    d: "M534 300h30v30h-30z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "icons Q2"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21498",
    d: "M549 301.25A13.75 13.75 0 1 0 562.75 315 13.75 13.75 0 0 0 549 301.25ZM560.25 315a10.75 10.75 0 0 1-.937 4.5L556 317.625a7.125 7.125 0 0 0 0-5.25l3.313-1.875a10.75 10.75 0 0 1 .937 4.5Zm-2.187-6.687-3.313 1.937a7.375 7.375 0 0 0-4.5-2.625v-3.812a11.438 11.438 0 0 1 7.813 4.5ZM549 310a5 5 0 1 1-5 5 5 5 0 0 1 5-5Zm0 16.25a11.25 11.25 0 0 1-1.25-22.438v3.813A7.5 7.5 0 0 0 549 322.5a7.375 7.375 0 0 0 5.75-2.75l3.313 1.937A11.375 11.375 0 0 1 549 326.25Z",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoughnutChartWhite);
export default __webpack_public_path__ + "static/media/doughnut-chart-white.58bc9f55c9ee0f83c30671dc296b4c81.svg";
export { ForwardRef as ReactComponent };